import "services/sentry";

// Bundled once here: flatpickr is pulled in by nine route chunks, which each got their own copy.
import "flatpickr/dist/flatpickr.css";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Vision UI Dashboard PRO React themes
import theme from "assets/theme";

// Vision UI Context Provider
import { VisionUIControllerProvider } from "context";

// Application state: auth, notifications, badges, dictionaries
import { AppProvider } from "context/app";

ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <VisionUIControllerProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </VisionUIControllerProvider>
    </ThemeProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
